import React from 'react';
import "./Horizontal.css"

export default function Horizontal() {
    return (
        <div className='horizontal'></div>
    );
}
